import { PaginationSchemaType, SearchResultQuery, SortOrder } from '@retro-ui/api-contract';

import { ResultFilters } from '../components/filtering/SearchResultFilters';

interface Query extends PaginationSchemaType {
  where: { [key: string]: any };
  orderBy: { [k: string]: SortOrder }[];
}

export function buildResultQuery(filters: ResultFilters, page: number): SearchResultQuery {
  const query: Query = {
    where: {},
    take: filters.pageSize,
    skip: (page - 1) * filters.pageSize,
    orderBy: filters.sorting.flatMap(([attribute, order]) => {
      if (attribute && order) {
        return [Object.fromEntries([[attribute, order]])];
      }
      return [];
    }),
  };

  if (filters.status.length > 0) {
    query.where.status = {
      in: filters.status,
    };
  }

  if (filters.targetFilter) {
    query.where.targetFilter = filters.targetFilter;
  }

  if (filters.result) {
    const [scoreFrom, scoreTo] = filters.result;
    query.where.result = {
      gte: scoreFrom,
      lte: scoreTo,
    };
  }

  if (filters.reactionCount) {
    const [reactionCountFrom, reactionCountTo] = filters.reactionCount;
    query.where.reactionCount = {
      gte: reactionCountFrom,
      lte: reactionCountTo,
    };
  }

  if (filters.price) {
    const [priceFrom, priceTo] = filters.price;
    query.where.price = {
      gte: priceFrom,
      lte: priceTo,
    };
  }

  return query;
}
